import React from "react";
import {
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    CircularProgress,
    Checkbox,
} from "@mui/material";

import DialogModel from "components/DialogModel/DialogModel";
import { ConvertToTitleCase, FormatDate } from "commonFunctions/commonFunctions";
import TablePage from "components/TablePage/TablePage";

const EhrEncountersTable = (props) => {
    return <div className="enc-data-section">

        <TableContainer component={Paper} className="enc-table">
            <Table stickyHeader aria-label="customized table">
                <TableHead className="thBorder">
                    <TableRow>
                        <TableCell className="tableHeadStyle">Select</TableCell>
                        <TableCell className="tableHeadStyle">No.</TableCell>
                        <TableCell className="tableHeadStyle">CSN</TableCell>
                        <TableCell className="tableHeadStyle">Encounter Start</TableCell>
                        <TableCell className="tableHeadStyle">Encounter End</TableCell>
                        <TableCell className="tableHeadStyle">Status</TableCell>
                        <TableCell className="tableHeadStyle">Encounter Name</TableCell>
                        <TableCell className="tableHeadStyle">Location</TableCell>
                        <TableCell className="tableHeadStyle">Provider</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!props.loader && props.encounterData &&
                        props.encounterData.map((data, i) => (
                            <TableRow
                                key={i}
                                className={props.documentLevel === "Encounter" && props.selectedEncounter === data.identifier ? "ehr-table-row-color" : "table-row"}>
                                <TableCell className="tableCellStyle" align="left">
                                    <Checkbox
                                        size="small"
                                        checked={props.documentLevel === "Encounter" && props.selectedEncounter === data.identifier ? true : false}
                                        onChange={(event) => props.handleEncounterSelection(event, data)}
                                        disabled={props.documentLevel !== "Encounter"}
                                    />
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.s_no}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.identifier}
                                </TableCell>
                                <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                    {data.period["start"] && FormatDate({ date: data.period["start"], format: "MM/DD/YYYY" })}
                                </TableCell>
                                <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                    {data.period["end"] && FormatDate({ date: data.period["end"], format: "MM/DD/YYYY" })}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {ConvertToTitleCase(data.status, "-")}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.type.toString()}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.location}
                                </TableCell>
                                <TableCell className="tableCellStyle" align="left">
                                    {data.participant[0].individual &&
                                        data.participant[0].individual.display}
                                </TableCell>

                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            {props.loader ? <CircularProgress size={30} className="popup-spinner" /> : (props.encounterData?.length === 0 && <DialogModel /> || null)}
        </TableContainer>
        <TablePage
            count={props.pagination.totalRecords}
            recordsPerPage={props.pagination.recordsPerPage}
            pageNum={props.pagination.currentPage}
            handleChangePage={props.handleChangePage}
        />
    </div>
}

export default EhrEncountersTable;